"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9 18h5.87L13 16.13l-1.1.3C9.89 16.99 9.08 17.76 9 18m8-10c0-1.1-.9-2-2-2-.99 0-1.81.72-1.97 1.67l2.31 2.31C16.27 9.82 17 8.99 17 8",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M14.48 11.95c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4c0 .18.03.35.05.52zM15 6c1.1 0 2 .9 2 2 0 .99-.73 1.82-1.67 1.97l-2.31-2.31C13.19 6.72 14.01 6 15 6m1.69 8.16L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84M0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71zm13.01 13.01L14.88 18H9c.08-.24.88-1.01 2.91-1.57zM6 9.12l.88.88H6z"
}, "1")], 'PersonAddDisabledTwoTone');